import React from 'react';

interface PromptConfirmationModalProps {
  isVisible: boolean;
  selectedPrompt: {
    prompt: string;
    wordCount: string;
    type: string;
  } | null;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
}

const PromptConfirmationModal: React.FC<PromptConfirmationModalProps> = ({
  isVisible,
  selectedPrompt,
  onConfirm,
  onCancel,
  title = "Confirm Prompt Selection"
}) => {
  if (!isVisible || !selectedPrompt) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="rounded-lg p-6 max-w-md w-full mx-4" style={{ background: 'var(--surface-primary)' }}>
        <h3 className="text-lg font-semibold mb-4">{title}</h3>
        <div className="mb-4">
          <div className="mb-2">
            <span className="font-medium">Word Count: </span>
            <span className="px-2 py-1 rounded-full text-xs" style={{ background: 'rgba(59, 130, 246, 0.12)', color: 'var(--info-dark)' }}>
              {selectedPrompt.wordCount} words
            </span>
          </div>
          <div>
            <span className="font-medium">Prompt: </span>
            <p className="mt-1" style={{ color: 'var(--text-secondary)' }}>{selectedPrompt.prompt}</p>
          </div>
        </div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onCancel}
            className="px-4 py-2" style={{ color: 'var(--text-secondary)' }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromptConfirmationModal;
